import script from "./RegistroEstabelecimentoPage_27.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroEstabelecimentoPage_27.vue?vue&type=script&setup=true&lang=js"

import "./RegistroEstabelecimentoPage_27.vue?vue&type=style&index=0&id=52709058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52709058"]])

export default __exports__